import { render } from "./SearchPatient.vue?vue&type=template&id=3e0d281c&scoped=true&ts=true"
import script from "./SearchPatient.vue?vue&type=script&lang=ts"
export * from "./SearchPatient.vue?vue&type=script&lang=ts"

import "./SearchPatient.vue?vue&type=style&index=0&id=3e0d281c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0d281c"]])

export default __exports__